import { Vue } from 'vue-class-component';
export default class WEmpty extends Vue {}